import React, { useState } from 'react'
import { Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../PendingReceivementsState'
import { useSelector } from 'src/utils/store'
import { useHistory } from 'react-router-dom'
import { ReceivementCategoryEnum } from 'src/features/pending-receivements/PendingReceivementsTypes'

interface ForwardButtonProps {
  receivementId?: string
}

export const ForwardButton = ({ receivementId }: ForwardButtonProps) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isDisabled, setIsDisabled] = useState(false)

  const badge = useSelector((state) => state.pendingReceivements.badge)
  const receivementConference = useSelector((state) => state.pendingReceivements.receivementConference)
  const approveCheckboxesValues = useSelector((state) => state.pendingReceivements.approveCheckboxesValues)

  const resolveForwardButtonIsDisabled = () => {
    const values = Object.values(approveCheckboxesValues)
    const receivementConferenceWithoutFlv = receivementConference?.receivementConference.filter((receivement) => !receivement.isFlv)
    const requiredChecks = receivementConferenceWithoutFlv?.length
    const allProductsConfirmed = receivementConference?.productWrong.every((product) => product.wrongProductConfirmed === true)

    if (!allProductsConfirmed) return true

    if (receivementConference?.idReceivementCategory
      && [ReceivementCategoryEnum.EXTERNAL_PURCHASE, ReceivementCategoryEnum.TRANSFER].includes(receivementConference?.idReceivementCategory)) return false

    if (values.length === requiredChecks) return values.some((isChecked) => !isChecked)

    return true
  }

  const onClick = () => {
    if (!receivementId || !receivementConference || isDisabled) {
      return
    }

    setIsDisabled(true)

    dispatch(actions.sendReceivementConference({
      badge, receivementId, receivementConference: receivementConference?.receivementConference, history, setIsDisabled,
    }))
  }

  return (
    <Button variant='contained' disabled={isDisabled || resolveForwardButtonIsDisabled()} onClick={onClick} data-testid='forward-button'>Prosseguir</Button>
  )
}
